import React, { Component } from "react";
import Skills from "../../containers/skills/Skills";

const Home = (props) => {
  console.log(props.theme);
  console.log(props.value1);

  return (
    <div>
      <Skills
        theme={props.theme}
        value1={props.value1}
        value2={props.value2}
        value3={props.value3}
        value4={props.value4}
        def1={props.def1}
        def2={props.def2}
        def3={props.def3}
        def4={props.def4}
        share1={props.share1}
        share2={props.share2}
        share3={props.share3}
        share4={props.share4}
        animation={props.animation}
      />
    </div>
  );
};

export default Home;
